import React from 'react'
import { useLocation } from 'react-router-dom'
import WebVitals from '@/components/common/WebVitals'
import Header from '@/components/layout/Header'
import CursorFX from '@/components/common/CursorFX'
import '@/styles/demo.css'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation()
  
  // トップページかどうかを判定
  const _isHomePage = location.pathname === '/'
  
  // デモページかどうかを判定
  const _isDemoPage = location.pathname.startsWith('/demos/')
  
  // ヘッダーを表示するかどうか（PCナビゲーション改善：全ページで表示）
  const showHeader = true
  
  // フッターは全ページで非表示にする
  const showFooter = false
  
  return (
    <>
      {/* demo-root はデモ専用リセット(demo.css)。サイト全体に付けるとレイヤー外の
          .demo-root a ルールが全リンクの色指定(link-action等)を潰すため付けない */}
      <div className="flex flex-col min-h-screen">
        {showHeader && <Header transparent showNavigation />}
        <main role="main" className={showHeader || showFooter ? "flex-1" : "min-h-screen"}>
          {children}
        </main>
        {/* Footer removed */}
      </div>
      {/* Global overlays */}
      <CursorFX />
      <WebVitals />
    </>
  )
}

export default Layout